<div class="row top">
  <div class="col-md-12">
    <div *ngIf="shouldShow()">
      <p-dataTable class="sm-padding-top"
                   #dt
                   [value]="pageSettings.storageTips[side]"
                   selectionMode="single"
                   [(selection)]="selectedStorageTip"
                   (onRowSelect)="onStorageTipRowSelect($event)"
                   [responsive]="true">
        <p-header>{{side === 'leftColumn' ? 'Left Column' : 'Right Column'}}</p-header>
        <p-column field="title"
                  header="Title"></p-column>
        <p-column field="body"
                  header="Body">
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="body">
            <span>{{car[col?.field]?.substring(0, 20)}}...</span>
          </ng-template>
        </p-column>
        <p-footer>
          <div class="ui-helper-clearfix"
               style="width:100%">
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="float:left"
                    (click)="showStorageTipDialogToAdd()">
              <i class="fa fa-plus"
                 aria-hidden="true"></i> Add
            </button>
          </div>
        </p-footer>
      </p-dataTable>
    </div>
  </div>
</div>

<p-dialog header="Storage Tip Details"
          [(visible)]="displayStorageTipDialog"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          [positionTop]="100"
          [width]="500"
          [dismissableMask]="true">
  <div class="ui-grid ui-grid-responsive ui-fluid"
       *ngIf="storageTip">
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="storageTip-title">Title</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="storageTip-title"
               [(ngModel)]="storageTip.title" />
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="storageTip-body">Body (HTML allowed)</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea pInputTextarea
                  id="storageTip-body"
                  [(ngModel)]="storageTip.body"></textarea>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button class="btn btn-secondary"
              *ngIf="!newStorageTip"
              style="float:left"
              (click)="deleteStorageTip()"><i class="fa fa-close"
           aria-hidden="true"></i> Delete</button>
      <button class="btn btn-primary"
              color="primary"
              (click)="saveStorageTip()"><i class="fa fa-check"
           aria-hidden="true"></i> Save</button>
    </div>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/ng2/app/components/storage-tips/storage-tips.component.html